import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import BugTrapIntakeForm from './BugTrapIntakeForm.js';
import BugTrapIssueList from './BugTrapIssueList.js';

export default function BugTrapModule() {
  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.textMuted, marginBottom: 8 }}>
        Bug Trap
      </div>
      <p style={{ marginTop: 0, lineHeight: 1.6 }}>
        Report a problem with the portal. Describe what you were doing, what happened, and how often it occurs. Issue list is visible to admins only.
      </p>

      <BugTrapIntakeForm />
      <BugTrapIssueList />
    </div>
  );
}
